import StandardBasketButton from './standardBasketButton'

export default StandardBasketButton
